module.exports = "<div class=\"input-container\">\n  <label for=\"typeDefautInput\" class=\"label-required\">Type de défaut</label>\n  <label ng-repeat=\"typedefautVal in $ctrl.typesDefaut.data | orderBy: 'id' track by typedefautVal.id\">\n    <input type=\"radio\" required name=\"typedefaut\" value=\"{{typedefautVal.id}}\" ng-model=\"$ctrl.data.typeDefaut\" ng-change=\"$ctrl.onChange({{typedefautVal.id}})\">{{typedefautVal.nomSitePublic}}\n  </label>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/components/type-defaut/type-defaut.html
// module id = 308
// module chunks = 0